class InfiniteScroll {
  constructor() {
    this.container = document.querySelector('#products');
    this.sentinel = document.querySelector('#infinite-scroll-sentinel');
    this.loader = document.querySelector('.infinite-scroll-loader');
    
    if (!this.container || !this.sentinel || !this.container.dataset.nextUrl) {
      console.log('Infinite Scroll: Page not compatible or no more results.');
      return;
    }

    this.nextUrl = this.container.dataset.nextUrl;
    this.isLoading = false;
    this.init();
  }

  init() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.isLoading && this.nextUrl) {
          this.loadMore();
        }
      });
    }, {
      rootMargin: '600px' // Load even earlier for seamless experience
    });

    observer.observe(this.sentinel);
  }

  async loadMore() {
    this.isLoading = true;
    this.showLoader();

    try {
      const response = await fetch(this.nextUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const newProducts = doc.querySelectorAll('#products > .product');
      const nextUrlElement = doc.querySelector('#products');
      
      if (newProducts.length > 0) {
        newProducts.forEach(product => {
          this.container.appendChild(product);
          // Apply lazy loading immediately to new images
          this.handleLazyLoad(product);
        });
        
        this.nextUrl = nextUrlElement ? nextUrlElement.dataset.nextUrl : null;
      } else {
        this.nextUrl = null;
      }
    } catch (e) {
      console.error('Infinite Scroll Error:', e);
      this.nextUrl = null;
    } finally {
      this.isLoading = false;
      this.hideLoader();
      if (!this.nextUrl) this.sentinel.remove();
    }
  }

  handleLazyLoad(parentElement) {
    const lazyImages = parentElement.querySelectorAll('img.lazy');
    if (!lazyImages.length) return;

    const lazyObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.classList.remove('lazy');
            lazyObserver.unobserve(img);
          }
        }
      });
    });

    lazyImages.forEach(img => lazyObserver.observe(img));
  }

  showLoader() { if (this.loader) this.loader.style.display = 'flex'; }
  hideLoader() { if (this.loader) this.loader.style.display = 'none'; }
}

document.addEventListener('DOMContentLoaded', () => new InfiniteScroll());
